import { useState, useEffect } from 'react';
import { Button } from "./ui/button";

export default function SystemLogsPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_BASE = "https://kiss-node-orchestrator-1057209991970.us-central1.run.app";

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/getAuditLogs`);
      if (!res.ok) throw new Error('Failed to fetch logs');
      const data = await res.json();
      setLogs(data.logs || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div className="space-y-4 font-mono text-green-400">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold uppercase tracking-wider">System Activity Audit Log</h2>
        <Button variant="outline" size="sm" onClick={fetchLogs} disabled={loading}>
          {loading ? "Refreshing..." : "Refresh Logs"}
        </Button>
      </div>

      {error && (
        <div className="p-3 border border-red-600 bg-red-900/20 text-red-400 text-sm">
          ERROR: {error}
        </div>
      )}

      <div className="border border-gray-700 rounded overflow-hidden">
        <table className="w-full text-left text-xs border-collapse">
          <thead>
            <tr className="bg-gray-900 border-b border-gray-700 text-gray-400 uppercase tracking-tighter">
              <th className="p-2 border-r border-gray-800">Timestamp</th>
              <th className="p-2 border-r border-gray-800">Endpoint</th>
              <th className="p-2 border-r border-gray-800">Query / Action</th>
              <th className="p-2 border-r border-gray-800">Status</th>
              <th className="p-2 border-r border-gray-800">Latency</th>
              <th className="p-2">IP</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            {logs.length === 0 && !loading ? (
              <tr>
                <td colSpan="6" className="p-8 text-center text-gray-600 italic">No activity recorded yet.</td>
              </tr>
            ) : (
              logs.map((log) => (
                <tr key={log.id} className="hover:bg-gray-900/50 transition-colors">
                  <td className="p-2 border-r border-gray-800 text-gray-500 shrink-0 whitespace-nowrap">
                    {new Date(log.created_at).toLocaleString()}
                  </td>
                  <td className="p-2 border-r border-gray-800 font-bold">
                    {log.endpoint}
                  </td>
                  <td className="p-2 border-r border-gray-800 max-w-xs truncate" title={log.query_text}>
                    {log.query_text || '-'}
                  </td>
                  <td className={`p-2 border-r border-gray-800 font-bold ${log.status_code >= 400 ? 'text-red-500' : 'text-green-500'}`}>
                    {log.status_code}
                  </td>
                  <td className="p-2 border-r border-gray-800 font-mono">
                    {log.response_time_ms}ms
                  </td>
                  <td className="p-2 text-gray-600 text-[10px]">
                    {log.user_ip}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      
      {!loading && logs.length > 0 && (
        <p className="text-[10px] text-gray-600 text-center uppercase tracking-widest">
          Showing last {logs.length} activity events
        </p>
      )}
    </div>
  );
}